<template>
  <div class="flex flex-col items-start justify-start h-full pl-5">
    <div class="-mt-16 mb-4 w-full flex">
      <div class="relative flex items-center justify-center">
        <ImgComponent
          class="rounded-full w-28 h-28 bg-white"
          src="/images/logo.png"
          alt=""
        />
        <div class="absolute title-color mt-10 right-2">Rider</div>
      </div>
    </div>
    <div class="fonr-bold">Solde</div>

    <div
      class="shimmerTarget rounded-lg mb-1 text-4xl title-color flex font-bold gap-1"
    >
      <DataFetcher dataKey="balance">
        <template #any="{ data }">
          <div>
            {{ Commons.formatNumber(data?.balance || '0') }}
          </div>
          <span class="text-sm">FCFA</span>
        </template>
      </DataFetcher>
    </div>
    <div class="flex gap-3">
      <button
        @click="requestWithdrawInfo"
        class="buttonComponent bg-[#ff9239] flex items-center gap-2 px-2 py-2"
      >
        <ColorImg
          class="bg-current w-5 h-5"
          src="/images/icons/withdraw.svg"
          alt=""
        />
        <div>Retirer</div>
      </button>
      <router-link
        to="/withdrawals"
        class="buttonComponent bg-transparent text-secondary border border-secondary flex items-center gap-2 px-2 py-2"
      >
        <!-- <ColorImg
          class="bg-current w-5 h-5"
          src="/images/icons/withdraw.svg"
          alt=""
        /> -->
        <div>Historique</div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import Events from '@/events/events'
// import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import ColorImg from '@/presentation/components/img/ColorImg.vue'
import DataFetcher from '@/features/data/presentation/components/DataFetcher.vue'
import ImgComponent from '@/presentation/components/img/ImgComponent.vue'
import { EVENTS } from '@/shared/constants/commons'
import Commons from '@/shared/utils/commons'
// import { ref } from 'vue'
import { createWithdrawal } from '@/project/data/services/withdrawal/createWithdrawal'

// const launchWithdrawalTrigger = ref(null)

async function requestWithdrawInfo() {
    Events.dispatch('open_withdrawal_modal')

}
</script>
